import React from 'react';
import PropTypes from 'prop-types';
import ProductListItem from './components/ProductListItem';

const productListDefaultPropMatches = [];
const ProductList = ({
  products,
  matches = productListDefaultPropMatches,
  onSelectMatch
}) => {
  return (
    <div className="grid w-full h-full">
      <div className="mb-5">
        {products?.map(product => (
          <ProductListItem
            key={product.productId}
            product={product}
            matchedProduct={matches.find(
              m => m.agrianEntityId === product.productId
            )}
            handleSelect={cwfSelectedProduct =>
              onSelectMatch(product, cwfSelectedProduct)
            }
          />
        ))}
      </div>
    </div>
  );
};

ProductList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string,
      productName: PropTypes.string
    })
  ).isRequired,
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string,
      productName: PropTypes.string
    })
  ),
  onSelectMatch: PropTypes.func.isRequired
};

export default ProductList;
